import type { CustomCellRendererProps } from 'ag-grid-react'

export function GridNumberCell(props: CustomCellRendererProps) {
  return (
    <span className="text-sm text-foreground">
      {(props.value as number) ?? 0}
    </span>
  )
}
